import {
  GET_VENDORS_SUCCESS,
  GET_VENDORS_FAIL,
  GET_VENDOR_PROFILE_SUCCESS,
  GET_VENDOR_PROFILE_FAIL,
  ADD_VENDOR_SUCCESS,
  ADD_VENDOR_FAIL,
  UPDATE_VENDOR_SUCCESS,
  UPDATE_VENDOR_FAIL,
  DELETE_VENDOR_SUCCESS,
  DELETE_VENDOR_FAIL,
  DELETE_VENDOR,
  ADD_NEW_VENDOR,
  UPDATE_VENDOR,
  SET_PAGE,
  SET_OFFSET,
  SET_QUERY
  
} from "./actionTypes";

const INIT_STATE = {
  vendors: [],
  vendorProfile: {
    vendor:{},
    types:[],
    settings:[],
    services:[],
  },
  error: {},
  loading:false,

    offset:0,
    page_size:10,
    query:''

};

const vendors = (state = INIT_STATE, action) => {
  // console.log(action)
  switch (action.type) {
    case GET_VENDORS_SUCCESS:
      return {
        ...state,
        vendors: action.payload.data,
        total_page:action.payload.total_page
      }

    case GET_VENDORS_FAIL:
      return {
        ...state,
        error: action.payload,
      }
    case ADD_NEW_VENDOR:
        return {
          ...state,
          loading:true
        }
    case ADD_VENDOR_SUCCESS:
      return {
        ...state,
        // vendors: [...state.vendors, action.payload],
        loading:false
      }

    case ADD_VENDOR_FAIL:
      return {
        ...state,
        error: action.payload,
        loading:false
      }
      case UPDATE_VENDOR:
        return {
          ...state,
          loading:true
        }
    case UPDATE_VENDOR_SUCCESS:
      return {
        ...state,
        vendors: state.vendors.map(vendor =>
          vendor.id.toString() === action.payload.id.toString()
            ? { ...vendor, ...action.payload }
            : vendor
        ),
        loading:false
      }

    case UPDATE_VENDOR_FAIL:
      return {
        ...state,
        error: action.payload,
        loading:false
      }
    case DELETE_VENDOR:
      return {
        ...state,
        loading:true
      }
    case DELETE_VENDOR_SUCCESS:
      return {
        ...state,
        vendors: state.vendors.filter(
          vendor => vendor.id.toString() !== action.payload.id.toString()
        ),
        loading:false
      }

    case DELETE_VENDOR_FAIL:
      return {
        ...state,
        error: action.payload,
      }

    case GET_VENDOR_PROFILE_SUCCESS:
      return {
        ...state,
        vendorProfile: action.payload,
      }

    case GET_VENDOR_PROFILE_FAIL:
      return {
        ...state,
        error: action.payload,
      }
      case SET_PAGE:
      return {
        ...state,
        page_size: action.payload,
      }
      case SET_OFFSET:
        return {
          ...state,
          offset: action.payload,
        }
        case SET_QUERY:
          return {
            ...state,
            query: action.payload,
          }
    default:
      return state
  }
};

export default vendors;
